// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Utils & Helpers
import cdnPrefixer from "helpers/cdnPrefixer";

// ** Styled Components
import {
	StyledAttachmentRemove,
	StyledAttachmentContainer,
	StyledAttachmentPreviewContainer,
	StyledAttachmentPreview,
} from "../styles";

// ** Cusstom Components
import { StyledOverlay } from "styles/components/Overlay.styled";

// ** SVG Static Imports
import { ReactComponent as SolidTrash } from "resources/icons/solid/trash.svg";

// ####################################################

const Attachment = ({
	preview,
	onClick,
	onRemove,
	removing,
	sending,
	customMarginTop,
	isRightSide,
	nextMinute,
}) => {
	const src = preview.includes("blob") ? preview : cdnPrefixer(preview);
	const { t } = useTranslation(["common"]);

	// ####################################################

	return (
		<StyledAttachmentContainer $customMarginTop={customMarginTop}>
			<StyledAttachmentPreviewContainer
				onClick={typeof onClick === "function" ? onClick : null}
				cursorPointer
				$customPadding={!nextMinute && !isRightSide ? "0" : null}
			>
				<StyledOverlay style={{ zIndex: 3 }} />
				<StyledAttachmentPreview src={src} />
			</StyledAttachmentPreviewContainer>
			{typeof onRemove === "function" ? (
				<StyledAttachmentRemove
					icon="trash"
					svgIconComponent={SolidTrash}
					label={t("common:delete")}
					onClick={onRemove}
					disabled={sending || removing}
					$customMargin={!nextMinute ? "0.25rem 0 0 0" : "0.25rem 0"}
					addBoxShadow
				/>
			) : null}
		</StyledAttachmentContainer>
	);
};

// ####################################################

export default Attachment;

// ####################################################
